import type { GivingBase, GivingInterval } from 'models';
import { useState } from 'react';
import type { AdditionalInfoFormValues, FormValuesAmount, RecurringFormValues } from '../../../components';
import { GiveNowItem } from '../create-give-steps/step-form/give-now-item';
import { GiveNowModal } from '../create-give-steps/step-form/give-now-modal';

export type CreateGiveNowValues = FormValuesAmount & Omit<AdditionalInfoFormValues, 'reason'> & RecurringFormValues;

type P = {
  getPathToGivingDetail: (id: string) => string;
  giving: GivingBase;
  interval: GivingInterval;
};

const GiveNowOption = ({ getPathToGivingDetail, giving, interval }: P) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <GiveNowItem
        getPathToGivingDetail={getPathToGivingDetail}
        giving={giving}
        onClick={() => {
          setIsModalOpen(true);
        }}
      />
      <GiveNowModal
        givingId={giving.id}
        interval={interval}
        isOpened={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      />
    </>
  );
};

export default GiveNowOption;
